module.exports = __webpack_public_path__ + "img/1469335684.c8ba32d2.jpg";